import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";
import { IonicModule } from "@ionic/angular";
import { NotificationDetailsPage } from "./details/notification-details";
import { NotificationPage } from "./main/notification";
const routes: Routes = [
    { path: 'details', loadComponent: () =>
      import('./details/notification-details').then(m => m.NotificationDetailsPage)
    },
    { path: '', loadComponent: () =>
      import('./main/notification').then(m => m.NotificationPage)
    }
  ];
@NgModule({
    declarations: [
      NotificationDetailsPage,
      NotificationPage
    ],
    imports: [
        HttpClientModule,
        SharedModule,
        CommonModule,
        RouterModule,
        SharedModule,
        IonicModule,
        TranslateModule,
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
    ]
  })
  export class NotificationModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }